import {type TranslationObject} from '@colonist/i18n'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup.ts'
import {uiManager} from '../EntryMobile.ts'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums.ts'

export class UIMViewPageNavigationWarningPopup extends ViewPopup {
    constructor(checkAction: () => void) {
        const title: TranslationObject = {key: 'strings:game.leaveGame.title'}
        const body: TranslationObject = {key: 'strings:game.leaveGame.navigationWarning'}

        const xAction: () => void = () => undefined
        const canCancel: boolean = true
        super(title, body, checkAction, xAction, canCancel)

        if(uiManager?.mainpageController?.sceneController?.scene == UIMSceneEnum.Game) {
            this.show()
        } else {
            checkAction()
            this.removePopup()
        }
    }
}
